import { IMenuItem } from '../../models/menu.model';
import { accountMenu } from './account.menu';
import { assetMenu } from './asset.menu';
import { claimMenu } from './claim.menu';
import { clientMenu } from './client.menu';
import { policyMenu } from './policy.menu';
import { investmentMenu } from 'projects/shared/src/lib/configs/menu-configs/investment.menus';

export const industryDataMenu: IMenuItem = {
  label: 'Industry Data Desk',
  id: 'MID_INDUSTRY_DATA_DESK',
  icon: 'fa fa-database',
  children: [policyMenu, investmentMenu, clientMenu, claimMenu, assetMenu, accountMenu],
};
